import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilters = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.5 2C6.5 1.17157 7.17157 0.5 8 0.5C8.82843 0.5 9.5 1.17157 9.5 2V6C9.5 6.82843 8.82843 7.5 8 7.5C7.17157 7.5 6.5 6.82843 6.5 6V2ZM0.5 4C0.5 3.72386 0.723858 3.5 1 3.5H3C3.27614 3.5 3.5 3.72386 3.5 4C3.5 4.27614 3.27614 4.5 3 4.5H1C0.723858 4.5 0.5 4.27614 0.5 4ZM12.5 4C12.5 3.72386 12.7239 3.5 13 3.5H19C19.2761 3.5 19.5 3.72386 19.5 4C19.5 4.27614 19.2761 4.5 19 4.5H13C12.7239 4.5 12.5 4.27614 12.5 4ZM16.5 16C16.5 15.7239 16.7239 15.5 17 15.5H19C19.2761 15.5 19.5 15.7239 19.5 16C19.5 16.2761 19.2761 16.5 19 16.5H17C16.7239 16.5 16.5 16.2761 16.5 16ZM0.5 16C0.5 15.7239 0.723858 15.5 1 15.5H7C7.27614 15.5 7.5 15.7239 7.5 16C7.5 16.2761 7.27614 16.5 7 16.5H1C0.723858 16.5 0.5 16.2761 0.5 16ZM10.5 14C10.5 13.1716 11.1716 12.5 12 12.5C12.8284 12.5 13.5 13.1716 13.5 14V18C13.5 18.8284 12.8284 19.5 12 19.5C11.1716 19.5 10.5 18.8284 10.5 18V14Z",
		fill: "#141414",
		stroke: "#141414"
	})
});
export default SvgFilters;
